import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
	IProfessionalAddress,
	IProfessionalAddressAppointments,
} from 'app/interfaces/address.interface';
import { environment } from 'environments/environment';

@Injectable({
	providedIn: 'root',
})
export class AddressService {
	url = environment.servicesUrl;

	constructor(private http: HttpClient) {}

	public getAddresses() {
		return this.http.get<IProfessionalAddress[]>(
			`${this.url}/professional/address`
		);
	}

	public getAddressById(id: string) {
		return this.http.get<IProfessionalAddress>(
			`${this.url}/professional/address/${id}`
		);
	}

	public getAddressAppointmentsById(id: string) {
		return this.http.get<IProfessionalAddressAppointments>(
			`${this.url}/professional/address/${id}/appointments`
		);
	}

	public createAddress(address) {
		return this.http.post<any>(
			`${environment.servicesUrl}/professional/address`,
			{ ...address }
		);
	}

	public updateAddress(id, address) {
		console.log('editAddress', address);
		return this.http.put<any>(
			`${environment.servicesUrl}/professional/address/${id}`,
			{ ...address }
		);
	}

	public removeAddress(id: string) {
		return this.http.delete<{ success: boolean }>(
			`${this.url}/professional/address/${id}`
		);
	}
}
